<template>
  <!-- 模块描述 -->
  <div class="module-title">
    <p>{{desc}}</p>
    <p style="padding-top:4px;" v-if="desc2">{{desc2}}</p>
  </div>
</template>
<script>
export default {
  props: {
    desc: {
      type: String,
      default: ''
    },
    desc2: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.module-title {
  font-size: 28px;
  font-weight: 400;
  color: #666464;
  line-height: 40px;
  text-align: center;
  margin-top: 24px;
}
</style>